import React, { Component, Fragment } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { FaPaperPlane, FaSyncAlt, FaArrowCircleUp, FaPaperclip } from 'react-icons/fa';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import ViewFile from './ViewFile';

import "react-table/react-table.css";

import userIcon from "../../../../assets/utils/images/originals/user.png";
import botIcon from "../../../../assets/utils/images/avatars/chatbot.png";
import axios from 'axios';
import Overlay from '../../../Overlay';
import UploadFile from './UploadFile';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { faClipboard } from '@fortawesome/free-solid-svg-icons';
import { properties } from '../../../../constants/Propertise';
import DownloadImage from './DownloadImage';
import ReactTable from 'react-table';
import ChartComponent from './ChartComponent';
import { century } from 'date-arithmetic';
import DownloadCSV from './DownloadCSV';


class AIChatbot extends Component {
  constructor(props) {
    super(props);
    this.chatContainerRef = React.createRef();

    this.state = {
      showUploadModel: false,
      username: '',
      chartDetailsResponse: [],
      showAlertModal: false,
      showFileModel: false,
      showGraphModel: false,
      viewChatModel: true,
      isBotTyping: false,
      input: '',
      //url:  process.env.REACT_APP_JavaAPI_URL+"/SGapp/Gen_pro/",
      url: "http://192.168.2.66:8001/common_bot/chatbot/",
      HisId: '',
      codeSnippet: '',
      mergedData: null,
      copied: false,
      isURL: '',
      // url:  process.env.REACT_APP_JavaAPI_URL+"/pdf/processQuery/" ,
      Graph_data: [],

      conversation: [

        { "role": "bot", "text": "Welcome to Neo Gen-AI, your ultimate AI-powered chat companion! How can I help you today? I can help you with metrics and charts on AI/ML Prediction and Correlation, Lead to Quote process as well as rephrasing and summarising text. Let Neo Gen-AI streamline your tasks and boost your productivity!" },

      ],
      minHeight: '50px',
      tableData: [],

      // tableData:[{"probablecause":"BatteryVoltage   High","node":"3BEW-20-04-PSY-0001","network":"SEM","probablecause_count":19661},{"probablecause":"BatteryTemp","node":"6CAN-04-02-PSY-0001","network":"SEM","probablecause_count":9700},{"probablecause":"Temp Equip Bay Low","node":"2KOG-22-060-PSY-0001","network":"SEM","probablecause_count":9617},{"probablecause":"Temp Equip Bay High","node":"2DEW-21-146-PSY-0001","network":"SEM","probablecause_count":9024},{"probablecause":"Temp Equip Bay Low","node":"3LON-09-021-PSY-0001","network":"SEM","probablecause_count":7734}],

      columns: [],
      // conversation:[

      //     { "role": "bot", "text": "Good day! How may I be of service to you today? Feel free to ask any questions or request assistance." },
      //     { "role": "user", "text": "Hi! I'm looking for information about vacation destinations. Can you help me find some popular places to visit?" },
      //     { "role": "bot", "text": "Of course! Are you interested in beach destinations, historical sites, adventurous locations, or something else?" },
      //     { "role": "user", "text": "I'm more inclined towards adventurous locations with scenic views." },
      //     { "role": "bot", "text": "Great choice! Some adventurous destinations with breathtaking views include the Swiss Alps, Machu Picchu in Peru, and the Grand Canyon in the United States. Which continent are you interested in?" },
      //     { "role": "user", "text": "I'm thinking about Europe. What activities can I do in the Swiss Alps?" },
      //     { "role": "bot", "text": "In the Swiss Alps, you can indulge in skiing, snowboarding, hiking, and mountaineering. The views of the majestic peaks and serene landscapes are simply mesmerizing. Is there anything specific you'd like to know about these activities?" },
      //     { "role": "user", "text": "That sounds fantastic! How about accommodation options and the best time to visit?" },
      //     { "role": "bot", "text": "There are various hotels, resorts, and chalets available in the Swiss Alps offering stunning views and cozy stays. The best time to visit for skiing is usually from December to March, while for hiking and enjoying the scenery, June to September is ideal. Would you like more details about specific accommodations or any other destination?" },
      //     { "role": "user", "text": "This is helpful! Can you suggest any famous historical sites in Europe as well?" },
      //     { "role": "bot", "text": "Certainly! Europe boasts numerous historical sites such as the Colosseum in Rome, the Acropolis in Athens, and the Stonehenge in England. Each of these sites holds rich historical significance and offers unique experiences. Is there anything specific you'd like to learn about these sites or any other inquiries?" },
      //     { "role": "user", "text": "I'm curious about the best time to visit these historical places and their significance. Could you provide more details?" },
      //     { "role": "bot", "text": "The best time to visit these historical sites varies. Generally, spring and autumn offer pleasant weather for exploring. The Colosseum served as an amphitheater for gladiator contests and public spectacles in ancient Rome. The Acropolis is an ancient citadel atop a rocky hill and is home to iconic structures like the Parthenon. Stonehenge is a prehistoric monument shrouded in mystery, believed to have been constructed around 3000 BC. Each site holds immense historical and cultural value. Would you like more information or assistance with anything else?" },
      //     { "role": "user", "text": "Thank you for the detailed information! I think I have what I need for now." },
      //     { "role": "bot", "text": "You're welcome! If you have any more questions or need further assistance in the future, feel free to ask. Have a wonderful day!" }

      // ],

    }
    this.onCopy = this.onCopy.bind(this);
  }
  componentDidMount = (event) => {

    this.scrollToBottom();
    // this.generateColumns(this.state.tableData);
    console.log("chatHistoryId" + localStorage.getItem('chatHistoryId'))
    const { match } = this.props;
    if (match) {
      const { id } = match.params;
      this.setState({
        HisId: id
      }, () => {
        localStorage.setItem('chatHistoryId', this.state.HisId);
        console.log('ID1:', this.state.HisId);
        if (this.state.HisId == 1) {
          this.setState({
            input: "Give me prediction analysis report for NBN Data"
          }, () => {
            this.sendMessage();
          });
        }
        else if (this.state.HisId == 2) {
          this.setState({
            conversation: [

              { "role": "bot", "text": "Welcome! I'm here to assist you with any questions or tasks you have. How can I make your day easier?" },
              { "role": "user", "text": "Please summarize the following email:'Hello Team, I hope this message finds you well. We're excited to announce our upcoming company event scheduled for [Date] at [Location]. The event will feature keynote speakers, networking opportunities, and exciting announcements about the future of our organization. We believe this event will be a valuable opportunity for you to connect with colleagues and gain insights into our company's direction.'" },
              { "role": "bot", "text": "The main differences between E1 and E3 licenses are as follows:\n\n1. Teams Features: Both E1 and E3 licenses include basic Microsoft Teams features like chat, file sharing, and online meetings. However, E3 includes additional advanced capabilities such as meeting scheduling assistance, cloud recording, and live events.\n\n2. Productivity Apps: E1 provides access to online versions of Office apps like Word, Excel, and PowerPoint. On the other hand, E3 includes full desktop versions of Office apps for both online and offline use.\n\n3. Security and Compliance: E1 offers basic security features like threat protection and anti-phishing. E3, on the other hand, provides advanced security features, compliance tools, and information protection capabilities.\n\n4. Enterprise Voice: E1 does not include any cloud-based telephony features. However, E3 includes integration with Phone System and cloud-based telephony capabilities.\n\nIn summary, E3 offers additional features and capabilities compared to E1, such as advanced Teams features, full desktop versions of Office apps, advanced security and compliance tools, and integration with Phone System for telephony capabilities. The choice between E1 and E3 depends on the specific needs and requirements of the organization. " },

            ]
          });
        }
        else if (this.state.HisId == 3) {
          this.setState({
            conversation: [

              { "role": "bot", "text": "Welcome! I'm here to assist you with any questions or tasks you have. How can I make your day easier?" },
              { "role": "user", "text": "What are SLAs for spare availability ?" },
              { "role": "bot", "text": "SLAs for spare availability are as follows:\n\n- London: Device replacement is possible in 6 hours.\n- Paris: Device replacement is possible in 8 hours.\n- Moscow: Device replacement is possible in 12 hours.\n- Berlin: Device replacement is possible in 6 hours.\n- Budapest: Device replacement is possible in 6 hours.\n- New York: Device replacement is possible in 8 hours.\n- Chicago: Device replacement is possible in 8 hours.\n- Madrid: Device replacement is possible in 6 hours." },

            ]
          });
        }
        else if (this.state.HisId == 4) {
          this.setState({
            conversation: [

              { "role": "bot", "text": "Welcome! I'm here to assist you with any questions or tasks you have. How can I make your day easier?" },
              { "role": "user", "text": "Do you have sample BOQ with cost for Head end" },
              { "role": "bot", "text": "Yes, I have a sample BOQ with cost for Head end. You can find a document called 'Headend_SD-WAN_BOQ_Cisco.pdf' which includes the cost for different routers with various capacities such as up to 50 Mbps, 100 Mbps Router, 250 Mbps Router, 500 Mbps Router, 2.5G Router, and 5G Router. The cost includes the product type as License and Support Type." },

            ]
          });
        }
        else {
          this.setState({
            conversation: [{ "role": "bot", "text": "Welcome to Neo Gen-AI, your ultimate AI-powered chat companion! How can I help you today? I can help you with metrics and charts on AI/ML Prediction and Correlation, Lead to Quote process as well as rephrasing and summarising text. Let Neo Gen-AI streamline your tasks and boost your productivity!" }]
          });
        }

      });

    }





  }



  componentDidUpdate() {
    if (this.state.viewChatModel === true) {
      this.scrollToBottom();
    }
  }

  handleSummerize = () => {
    const summerizingText = "Summarize the following text for me: <"
    this.setState(
      {
        input: summerizingText + this.state.input + ">",
        minHeight: '50px',
      }, () => {
        this.sendMessage();
      }
    );
  }

  handleRephrase = () => {
    const rephraseText = "Rephrase and correct the following text: <"
    this.setState(
      {
        input: rephraseText + this.state.input + ">",
        minHeight: '50px',
      }, () => {
        this.sendMessage();
      }
    );
  }

  scrollToBottom() {
    // Scroll to the bottom of the chat
    this.chatContainerRef.current.scrollTop = this.chatContainerRef.current.scrollHeight;
  }

  showUploadModel = () => {
    this.setState(
      {
        showUploadModel: true,
      }
    );
  }

  closeUploadModel = () => {
    this.setState(
      {
        showUploadModel: false,

      }
    );
  }




  sendMessage = async () => {
    const { input, conversation } = this.state;

    this.setState({
      conversation: [
        ...conversation,
        { role: 'user', text: input },

      ],
      input: '',

      isBotTyping: true
    });
    // Send user message to the server
    try {
      const url = process.env.REACT_APP_JavaAPI_URL + "/SGapp/Gen_pro/";
      // const url=  process.env.REACT_APP_JavaAPI_URL+"/pdf/processQuery/" ;
      const response = await axios.post(this.state.url, { query: input });
      const codeBlocks = response.data.text.match(/```([^`]+)```/g);
      console.log("codeblocks" + codeBlocks)

      const textMessage = response.data.text.replace(/```([^`]+)```/g, '');


      const mergedData = { textMessage, codeBlocks };

      const isURL = this.isUrl(textMessage)
      this.setState({
        mergedData
      });

      const columns = [];
      const keys = new Set();
      response.data.table.forEach(obj => {
        Object.keys(obj).forEach(key => keys.add(key));
      });
      keys.forEach(key => {
        columns.push({
          Header: key,
          accessor: key
        });
      });


      if (isURL) {
        this.setState({
          conversation: [
            ...conversation,
            { role: 'user', text: input },
            { role: 'bot', text: textMessage, source_document: response.data.pdf, codeBlocks: codeBlocks, image: response.data.img, tableData: response.data.table, columns: columns },
          ],
          input: '',
          isBotTyping: false,
          codeSnippet: codeBlocks
        });
      }

      else {
        this.setState({
          conversation: [
            ...conversation,
            { role: 'user', text: input },
            { role: 'bot', text: textMessage, source_document: response.data.pdf, image: response.data.img, codeBlocks: codeBlocks, tableData: response.data.table, columns: columns },
          ],
          input: '',
          isBotTyping: false,
          codeSnippet: codeBlocks
        });
      }
    } catch (error) {
      console.error('Error sending message:', error);
      this.setState({
        conversation: [
          ...conversation,
          { role: 'user', text: input },
          { role: 'bot', text: "Sorry, I didn't understand. Can you please rephrase your query?" },
        ],
        input: '',
        isBotTyping: false
      });
    }
  };


  handleDownload = (source) => {
    // Implement your logic to handle document download here
    console.log('Downloading document:', source);
    // You can use the source path to initiate the download
  };

  extractDocumentName = (source) => {
    // Extract the last part of the source path as the document name
    const parts = source.split('/');
    return parts[parts.length - 1];
  };

  getUpdateFileDetails = (data, fileName) => {
    const url = data;
    this.setState({
      File_data: url,
      FileName: fileName

    }, () => {
      this.FileCloseTab();
    });


  }

  FileCloseTab = () => {
    this.setState({

      showFileModel: !this.state.showFileModel,
      viewChatModel: !this.state.viewChatModel,

    })
  }

  handleGraph = (graphData) => {

    this.setState({
      Graph_data: graphData

    }, () => {
      this.GraphCloseTab();
    });
  }

  GraphCloseTab = () => {
    this.setState({

      showGraphModel: !this.state.showGraphModel,
      viewChatModel: !this.state.viewChatModel,

    })

  }

  renderDocumentButtons = (sourceDocument) => {
    const uniqueDocumentNames = new Set();
    const BasePathProcess = "/VM_Data/Generative_AI_test/PDF_gen/pdf_gen_ai/pdf/";
    const BasePathLTC = "/VM_Data/Generative_AI_test/PDF_gen/pdf_gen_ai/pdf/";
    const NewBasePath = "/pdf/";
    const containsLTC = this.state.url.includes('/pdf/LTC_Query/');




    const documentName = this.extractDocumentName(sourceDocument);
    const url = "http://192.168.2.112:8005/gen_ai/LTC_Docs/" + documentName;

    const transformedPath = url.replace(BasePathLTC, NewBasePath);
    // Display the button only if it's a new document
    if (!uniqueDocumentNames.has(documentName)) {
      uniqueDocumentNames.add(documentName);
      return (
        <button onClick={() => this.getUpdateFileDetails(url, documentName)} className='btn btn-primary' style={{ margin: '5px' }}>
          {documentName}
        </button>
      );



    }
  };


  handleRestart = () => {
    // Reset the chat state
    this.setState({
      input: '',
      conversation: [

        { "role": "bot", "text": "Welcome to Neo Gen-AI, your ultimate AI-powered chat companion! How can I help you today? I can help you with metrics and charts on AI/ML Prediction and Correlation, Lead to Quote process as well as rephrasing and summarising text. Let Neo Gen-AI streamline your tasks and boost your productivity!" },

      ]
    });
  };

  handleKeyDown = (e) => {
    const { input } = this.state;
    if (e.key === 'Enter' && e.shiftKey) {
      e.preventDefault();
      this.setState({ input: input + '\n' }, () => {

        this.textArea.scrollTop = this.textArea.scrollHeight;

        const inputLines = this.state.input.split('\n').length;
        const newHeight = Math.min(inputLines * 30, 100) + 'px'; // Adjust line height as needed
        this.setState({ minHeight: newHeight });
      });
    } else if (e.key === 'Enter') {
      e.preventDefault();
      this.sendMessage();
      // Scroll to the bottom of the textarea after sending the message
      this.textArea.scrollTop = this.textArea.scrollHeight;
      // Reset minHeight to default value after sending the message
      this.setState({ minHeight: '50px' });
    }
  };

  handleInputChange = (e) => {
    const inputLines = e.target.value.split('\n').length;
    const newHeight = Math.min(inputLines * 30, 100) + 'px'; // Adjust line height as needed
    this.setState({ input: e.target.value, minHeight: newHeight });
  };

  onCopy() {
    this.setState({ copied: true });
    setTimeout(() => {
      this.setState({ copied: false });
    }, 1500);
  }

  isUrl(string) {
    const urlRegex = /(https?:\/\/[^\s]+)/;
    return urlRegex.test(string);
  }

  generateColumns(data) {
    const columns = [];
    const keys = new Set();
    data.forEach(obj => {
      Object.keys(obj).forEach(key => keys.add(key));
    });
    keys.forEach(key => {
      columns.push({
        Header: key,
        accessor: key
      });
    });
    this.setState({
      columns: columns
    })
  }


  render() {

    const { input, conversation } = this.state;


    return (
      <Fragment>

        {/* <div className="app-page-title">
                            <div className="page-title-wrapper">
                                <div className="page-title-heading">
                                    <div>
                                    Neo Gen-AI
                                    </div>
                                </div>

                            </div>
                        </div> */}
        {this.state.viewChatModel && <div className="aiMain-chat-container">
          <div >
            <div className="aiMain-message-box-container" ref={this.chatContainerRef} >
              {conversation.map((msg, index) => {

                const message = msg.text.split('\n');
                const table = msg.tableData;
                console.log("message", JSON.stringify(conversation));
                return (
                  <div key={index} className={msg.role === 'user' ? 'aiMain-user-message-container' : 'aiMain-bot-message-container'}>
                    {msg.role !== 'user' &&
                      <React.Fragment>

                        <div className="aiMain-label">  <img src={botIcon} alt="Bot Icon" className="aiMain-icon" />{properties.aiName}</div>
                      </React.Fragment>
                    }
                    <div
                      className={msg.role === 'user' ? 'aiMain-user-message' : 'aiMain-bot-message'}
                    >
                      {/* {message} */}


                      {message.map((line, index) => (
                        <div key={index}>{line}</div>
                      ))}

                      {msg.codeBlocks &&

                        msg.codeBlocks.map((codeBlock, index) => (
                          <>
                            <CopyToClipboard text={codeBlock.replace(/```/g, '')} onCopy={this.onCopy}>
                              <FontAwesomeIcon icon={faClipboard} className='copyIcon' />
                            </CopyToClipboard>
                            <SyntaxHighlighter key={index} language="javascript" style={vscDarkPlus} className='codeSnippetContainer'>
                              {codeBlock.replace(/```/g, '')}
                            </SyntaxHighlighter></>
                        ))}

                      {msg.tableData && msg.tableData.length > 0 &&
                        <DownloadCSV
                          data={msg.tableData}

                        />
                      }
                      {msg.tableData && msg.tableData.length > 0 &&
                        <div style={{ width: '100%' }}>
                          <br />
                          <ReactTable
                            data={msg.tableData}
                            columns={msg.columns}
                            minRows={0}
                            showPagination={msg.tableData.length > 13}
                            defaultPageSize={10}
                            style={{
                              backgroundColor: "#fafafa", width: 'auto',
                              height: 'auto',
                            }}
                            className="-striped -highlight"
                          />

                          <br />
                          <br />
                        </div>

                      }
                      {/* {
                        msg.tableData && msg.tableData.length > 0 && <ChartComponent data={msg.tableData} />
                      }
                      {
                        msg.tableData && msg.tableData.length > 1 && msg.tableData.length < 12 && msg.columns.length < 4 &&
                        <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                          <button onClick={() => this.handleGraph(msg.tableData)} className='btn btn-primary' style={{ margin: '5px' }}>
                            Display Graph
                          </button>
                        </div>
                      } */}


                      {msg.image &&
                        <div style={{ margin: '5px', width: '100%' }} className='mr-3 mb-3'>
                          <DownloadImage
                            chartName={this.state.chartName}
                            type={this.props.type}
                            imagePath={msg.image}
                          />
                        </div>
                      }
                      {msg.image && <img src={msg.image} className="chatImage" alt="Fetched Image" />}



                    </div>
                    {msg.role === 'user' &&
                      <React.Fragment>

                        <div className="aiMain-userlabel"> <img src={userIcon} alt="User Icon" className="aiMain-icon" /></div>

                      </React.Fragment>
                    }

                    <div className='chat_buttons'>



                    </div>

                    <div className='chat_buttons'>


                      {msg.source_document &&
                        this.renderDocumentButtons(msg.source_document)}
                    </div>

                  </div>

                )
              })}
              {this.state.isBotTyping && (
                <div className='aiMain-bot-message-container'>
                  <React.Fragment>

                    <div className="aiMain-label">  <img src={botIcon} alt="Bot Icon" className="aiMain-icon" />{properties.aiName}</div>
                  </React.Fragment>
                  <div className="aiMain-bot-message"> <div className="aiMain-typing-dots-container">
                    <span className="aiMain-typing-dots"></span>
                    <span className="aiMain-typing-dots"></span>
                    <span className="aiMain-typing-dots"></span>
                  </div>
                  </div></div>

              )}

            </div>
          </div>
          <div className="aiMain-input-container">
            <FaSyncAlt className="send-icon aiMain-chat-restart-button" type="submit" onClick={this.handleRestart} style={{ color: "#033C73" }} />
            {/* <FaPaperclip className="send-icon"  onClick={this.showUploadModel} style={{ fontSize: '30px',marginTop: "6px",marginLeft:"4px",marginRight:"8px",color:"#033C73" }}/>
             */}
            <textarea
              type="text"
              value={input}
              onKeyDown={this.handleKeyDown}
              onChange={this.handleInputChange}
              placeholder="Type your message..."
              className='grammerChatInput'
              style={{ minHeight: this.state.minHeight }}
              ref={(textarea) => { this.textArea = textarea; }}
              rows={1}
            />
            <FaArrowCircleUp className="send-icon aiMain-chat-send-button" type="submit" onClick={this.sendMessage} style={{ color: "#033C73" }} />

          </div>
          <div className="grammer-button-container" >
            <button className="btn btn-primary grammer-button" onClick={() => this.handleSummerize()}>Summarize</button>
            <button className="btn btn-primary grammer-button" onClick={() => this.handleRephrase()}>Rephrase</button>
          </div>
        </div>
        }


        {this.state.showFileModel &&
          <div>
            <button className="btn btn-primary" onClick={this.FileCloseTab}>
              <FontAwesomeIcon icon={faArrowLeft} />
              <span className="back-text">   Back</span>
            </button><br /><br />

            <ViewFile
              File_data={this.state.File_data}
              FileName={this.state.FileName}
              backMethod={this.FileCloseTab}


            />


          </div>}

        {this.state.showGraphModel &&
          <div>
            <button className="btn btn-primary" onClick={this.GraphCloseTab}>
              <FontAwesomeIcon icon={faArrowLeft} />
              <span className="back-text">   Back</span>
            </button><br /><br />

            <ChartComponent
              Graph_data={this.state.Graph_data}
              backMethod={this.GraphCloseTab}


            />


          </div>}


        <Overlay
          title="Upload File"
          // subTitle={this.state.AllUsersToUpdate['allUsers']}
          openOverlay={this.state.showUploadModel}
          closeOverlay={this.closeUploadModel}
          className="completemodal"
        >
          <UploadFile />

        </Overlay>

      </Fragment>
    )
  }
}

export default AIChatbot;
